import Hero from '../components/Hero'
import AboutSection from '../components/AboutSection'
import RoomsSection from '../components/RoomsSection'
import BreakfastSection from '../components/BreakfastSection'
import FeaturesSection from '../components/FeaturesSection'
import LocationSection from '../components/LocationSection'
import ContactForm from '../components/ContactForm'

function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <RoomsSection />
      <BreakfastSection />
      <FeaturesSection />
      <LocationSection />
      <ContactForm />
    </>
  )
}

export default Home
